import api from '../service/service.js'
import Swal from 'sweetalert2'
export default {
  name: 'member',
  data () {
    return {

      prefix_id: 1,
      l_name: '',
      f_name: '',
      username: '',
      password: '',
      conpassword: '',
      gender_id: 1,
      position: '',
      role_id: 1,
      active_status: 0,
      prefix: [],
      gender: [],
      role: []
    }
  },
  methods: {
    addUser () {
      if (this.password !== this.conpassword) {
        Swal.fire(
          'ข้อความจากระบบ',
          'กรุณากรอกรหัสผ่านให้ตรงกัน',
          'warning'
        )
        return 1
      }
      if (this.username === '' || this.password === '' || this.l_name === '' || this.f_name === '' || this.position === '') {
        Swal.fire(
          'ข้อความจากระบบ',
          'กรุณากรอกข้อมูลให้ครบถ้วน',
          'warning'
        )
        return 1
      }

      if (this.password.length < 6) {
        Swal.fire(
          'ข้อความจากระบบ',
          'รหัสผ่านต้องไม่น้อยกว่า 6 ตัวอักษร',
          'warning'
        )
        return 1
      }

      let payload = {
        username: this.username,
        password: this.password,
        prefix_id: this.prefix_id.toString(),
        fname: this.f_name,
        lname: this.l_name,
        gender_id: this.gender_id.toString(),
        position: this.position,
        role_id: this.role_id.toString(),
        active_status: this.active_status.toString()
      }
      console.log(payload)
      api.Adduser(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            this.alert_msg(
              'success',
              'ข้อความจากระบบ',
              'บันทึกสำเร็จ '
            )
            this.clear()
            this.$router.push({ name: 'users' })
          } else {
            Swal.fire(
              'ข้อความจากระบบ',
              result.data,
              'warning'
            )
          }
        },
        calback => {
          Swal.fire(
            'ข้อความจากระบบ',
            calback,
            'error'
          )
          console.log(calback)
        })
    },
    clear () {
      this.prefix_id = 0
      this.l_name = ''
      this.f_name = ''
      this.username = ''
      this.password = ''
      this.conpassword = ''
      this.role_id = 0
      this.gender_id = 0
      this.position = ''
    },
    getgender () {
      api.gender(
        result => {
          console.log(result)
          if (result.result === true) {
            this.gender = result.data
          }
        },
        calback => {
          console.log(calback)
        })
    },
    getprefix () {
      api.prefix(
        result => {
          console.log(result)
          if (result.result === true) {
            this.prefix = result.data
            console.log(this.prefix)
          }
        },
        calback => {
          console.log(calback)
        })
    },
    getRole () {
      api.role(
        result => {
          console.log(result)
          if (result.result === true) {
            this.role = result.data
          }
        },
        calback => {
          console.log(calback)
        })
    }
  },
  mounted () {
    this.getgender()
    this.getprefix()
    this.getRole()
    //  console.log(this.menu)
  }
}



// WEBPACK FOOTER //
// ./src/js/adduser.js